import { render, staticRenderFns } from "./CircleHollowIcon.vue?vue&type=template&id=00956080&"
import script from "./CircleHollowIcon.vue?vue&type=script&lang=js&"
export * from "./CircleHollowIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports